export const appKeys = {
  list: () => ["apps"] as const,
  app: (id: number | string | undefined) => ["instances", id] as const,
  item: (id?: string) => ["app", id] as const,

};
